const validations = {
  deadline: {
    required: true,
    isDate: true,
  },
};

export { validations };
